import React from 'react';
import { ShoppingCartIcon } from 'lucide-react';
import { CART_LINK } from '../constants/content';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
}
/**
 * Primary conversion button. Fires the Meta Pixel "AddToCart" event on click
 * (if the pixel is loaded), then redirects to the Shopify checkout.
 */
export function CtaButton({
  children,
  className = ''
}: CtaButtonProps) {
  return <a href={CART_LINK} onClick={() => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
  }} className={`group inline-flex w-full items-center justify-center gap-3 rounded-xl bg-crimson px-6 py-4 text-center font-display text-xl font-600 uppercase tracking-wide text-white shadow-lg shadow-crimson/30 ring-2 ring-crimson-dark/30 transition-all hover:-translate-y-0.5 hover:bg-crimson-dark hover:shadow-xl focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-2xl ${className}`} data-id="element-46">
      <ShoppingCartIcon className="h-6 w-6 shrink-0 transition-transform group-hover:scale-110" aria-hidden="true" data-id="element-47" />
      <span data-id="element-48">{children}</span>
    </a>;
}